const API_URL = process.env.REACT_APP_API_URL;

let apiUrls =  {
    elements: `${API_URL}/employees`,
    search: `${API_URL}/employee/search`,
    information: `${API_URL}/employee/information`,
};

export default apiUrls;
